// extracted by mini-css-extract-plugin
export default {"SendDocumentButton":"_SendDocumentButton--Nbx2r","Collapsed":"_Collapsed--jiE_O","Expanded":"_Expanded--ELnHu"};